var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconElektroSchwarz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.66 25.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg4993"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6492",
    d: "M.11,14.57A13.05,13.05,0,0,1,.92,8,14.07,14.07,0,0,1,3.25,4.28,13.09,13.09,0,0,1,8.5.75,12.88,12.88,0,0,1,23.18,5.23a17.26,17.26,0,0,1,1.73,3.23,13,13,0,0,1,.55,6.64A12.84,12.84,0,0,1,10.62,25.49a11.77,11.77,0,0,1-4.72-2,5.21,5.21,0,0,1-1.82-1.94,4,4,0,0,1-.29-3.27,4.09,4.09,0,0,1,.66-1.32,9.56,9.56,0,0,1,3-2.67c.42-.26.79-.49.82-.52s0-.1,0-.17A4.89,4.89,0,0,1,8,12.27a4.16,4.16,0,0,1,1.22-3c.25-.26.3-.29,2.29-1.37l2-1.11,2.37,4.43,2.37,4.43L16.23,16.7c-2,1.05-2.06,1.08-2.42,1.14A4.11,4.11,0,0,1,9.7,16.26a1.87,1.87,0,0,0-.24-.3,17.73,17.73,0,0,0-1.73,1.12c-1.26,1-1.83,2-1.65,2.82a2.34,2.34,0,0,0,.61,1,9.67,9.67,0,0,0,3.59,1.94A10.23,10.23,0,0,0,17.72,22a9.77,9.77,0,0,0,2.82-2.19,10.59,10.59,0,0,0,2.63-6.32,10.73,10.73,0,0,0,0-1.14,10.38,10.38,0,0,0-14.51-9A10.39,10.39,0,0,0,2.55,14.18c.1.85.08,1-.14,1.36a1.21,1.21,0,0,1-1.74.3c-.34-.26-.46-.53-.56-1.27ZM16.36,7.14c1.23-.66,1.32-.7,1.5-.69s.5.15.71.55.24.6.09.84-.18.21-1.43.88l-1.34.72-.42-.8L15,7.84l1.32-.7Zm2.34,4.32c1.25-.67,1.35-.71,1.52-.7s.44.15.65.55a.78.78,0,0,1,.07.89c-.09.15-.18.21-1.41.87l-1.32.7L17.78,13l-.42-.8,1.34-.72Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconElektroSchwarz);
export default __webpack_public_path__ + "static/media/icon_elektro_schwarz.e34b9d14827494cba64086be824f2460.svg";
export { ForwardRef as ReactComponent };